import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard implements CanActivate {

  constructor(
    private router: Router,
    private afa: AngularFireAuth
  ) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.afa.user.pipe(
      map(user => {
        if (!user) {
          return this.router.createUrlTree(['/login']);
        }
        return true;
      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class NotAuthenticatedGuard implements CanActivate {

  constructor(
    private router: Router,
    private afa: AngularFireAuth
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.afa.user.pipe(
      map(user => {
        if (!!user) {
          return this.router.createUrlTree(['/']);
        }
        return true;
      })
    );
  }
}
